import styled from 'styled-components'

export const Circle = styled.circle``
